<form [formGroup]="form" (ngSubmit)="onSave()">
	@if (httpError) {
	<mat-error class="top-right-absolute-error-message">{{ 'mes.administration.department.dialog.alias.errors.duplicate-error' | translate }}</mat-error>
	}

	<h1 mat-dialog-title class="notification-title">{{ (isEdit ? 'mes.administration.department.dialog.edit-department' : 'mes.administration.department.dialog.create-department') | translate }}</h1>

	<mat-dialog-content style="padding-top: 20px">
		@if (controls['alias'].invalid && (controls['alias'].touched)) {
		<mat-error>{{ 'mes.administration.department.dialog.alias.errors.' + getFirstValidationErrorName('alias') | translate}}</mat-error>
		}
		<mat-form-field appearance="outline" class="dialog">
			<mat-label class="mat-body-1">{{ 'mes.administration.department.dialog.alias.label' | translate }}</mat-label>
			<input maxlength="50" matInput formControlName="alias" />
		</mat-form-field>

		@if (controls['name'].invalid && (controls['name'].touched || isEdit)) {
		<mat-error>{{ 'mes.administration.department.dialog.name.errors.' + getFirstValidationErrorName('name') | translate }}</mat-error>
		}
		<mat-form-field appearance="outline" class="dialog">
			<mat-label class="mat-body-1">{{ 'mes.administration.department.dialog.name.label' | translate }}</mat-label>
			<input maxlength="255" matInput formControlName="name" />
		</mat-form-field>

		@if (form.controls['shiftApprover'].hasError('required') && form.controls['shiftApprover'].touched) {
		<mat-error>{{ 'mes.administration.department.dialog.shift-approver.errors.required-error' | translate }}</mat-error>
		}
		<mat-form-field appearance="outline" class="dialog">
			<mat-label class="mat-body-1">{{ 'mes.administration.department.dialog.shift-approver.label' | translate }}</mat-label>
			<mat-select formControlName="shiftApprover">
				@for (user of availableUsers; track user) {
				<mat-option [value]="user">{{ user.name }} ({{ user.email }})</mat-option>
				}
			</mat-select>
		</mat-form-field>

		<mat-form-field appearance="outline" class="dialog">
			<mat-label class="mat-body-1">{{ 'mes.administration.department.dialog.backup-shift-approver.label' | translate }}</mat-label>
			<mat-select formControlName="backupShiftApprover">
				<mat-option [value]="null">{{ 'mes.administration.department.dialog.backup-shift-approver.none' | translate }}</mat-option>
				@for (user of availableUsers; track user) {
				<mat-option [value]="user">{{ user.name }} ({{ user.email }})</mat-option>
				}
			</mat-select>
		</mat-form-field>

		<mat-label class="mat-body-1">{{ 'mes.administration.department.dialog.active.label' | translate }}</mat-label>
		<mat-checkbox formControlName="isActive" />
	</mat-dialog-content>

	<mat-dialog-actions align="end">
		<button mat-flat-button color="primary" type="submit" [disabled]="isLoading || form.invalid" [ngClass]="{ 'disabled-button': isLoading }">{{ 'mes.administration.department.dialog.okbtn' | translate }}</button>
		<button mat-stroked-button type="button" (click)="onCancel()" (window:keyup.escape)="onCancel()" class="button-border-color">{{ 'mes.administration.department.dialog.cancelbtn' | translate }}</button>
	</mat-dialog-actions>
</form>
